export default "__VITE_ASSET__f1c56449__"